module.exports = __webpack_public_path__ + "static/img/AX@3x.11719489.jpg";